import React from 'react';

import './CardSalaSistema.css';

import imgSistemas1 from '../../../assets/img/imagenes-espacios/sistemas1.jpg';
import imgSistemas2 from '../../../assets/img/imagenes-espacios/sistemas2.png';
import imgSistemas3 from '../../../assets/img/imagenes-espacios/sistemas3.png';

const fotos = [
  {
    src: imgSistemas1,
    alt: 'Sala de sistemas con computadores en fila y sillas blancas',
  },
  {
    src: imgSistemas2,
    alt: 'Estudiantes y equipos de cómputo en la sala de sistemas',
  },
  {
    src: imgSistemas3,
    alt: 'Proyección de soporte a computadores en la sala de sistemas',
  },
];

const CardSalaSistema = () => {
  return (
    <div className="card-sala-wrap">
      <article className="card-sala">
        <div className="card-sala__bar" />

        <div className="card-sala__body">
          <h2 className="card-sala__title">Sala de Sistemas</h2>

          <p className="card-sala__description">
            La Sala de Sistemas del Instituto de Educación de la Cruz Roja Seccional Sucre
            está equipada con tecnología moderna para el desarrollo de competencias digitales.
            Los estudiantes acceden a herramientas informáticas que fortalecen su formación
            en áreas como ofimática, programación, diseño web y gestión de datos. Este espacio
            promueve el aprendizaje autónomo, la innovación tecnológica y el uso responsable
            de los recursos digitales en contextos educativos y profesionales.
          </p>

          <div className="card-sala__gallery">
            {fotos.map((foto) => (
              <figure key={foto.alt} className="card-sala__figure">
                <img
                  src={foto.src}
                  alt={foto.alt}
                  className="card-sala__img"
                />
              </figure>
            ))}
          </div>
        </div>
      </article>
    </div>
  );
};

export default CardSalaSistema;